import React, { useEffect, useRef } from "react";
import styles from "../components/comp_css/chapter_58.module.css";
import { Link } from "@mui/material";
import { useRouter } from "next/router";
import Common_html from "./Common_html";
import BlockData from "../../../central-doctraine-json/chapter60.json";
import Head from "next/head";
export default function Chapter_60() {

  const router = useRouter()
  const location = useRouter();
  const { pathname } = location;

  // const corosalref = useRef()

  // useEffect(() => {
  //     if (corosalref.current) {
  //         corosalref.current.scrollIntoView({
  //             behavior: "smooth",
  //             block: "nearest",
  //             inline: "start"
  //         })
  //     }
  //     console.log("CurrentImageComponent", corosalref.current);
  // }, [corosalref.current])
  return (
    <>
      <Head>
        <title>Central Doctrine | School of Our Divine Infinite Being</title>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0"
        ></meta>
        <meta
          name="keywords"
          content="Donald Hoffman, Conscious Realism, Iamblichean Platonism, double-aspect monism, theurgy, consciousness, matter, Unus Mundus, ontology, Tao."
        ></meta>
        <meta
          property="og:title"
          content="Donald Hoffman’s Conscious Realism and Iamblichean Platonism in Dialogue"
        ></meta>
        <meta property="og:type" content="website"></meta>
        <meta
          property="og:image"
          content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/central_doctrinel_og_img.webp"
        ></meta>
        <meta
          property="og:image:alt"
          content="Illustration of a radiant, ethereal figure surrounded by a golden aura, symbolizing the Divine Infinite Being. The figure is positioned centrally, emanating light and energy, with abstract patterns representing spiritual interconnectedness and universal truth."
        ></meta>
        <meta
          property="og:description"
          content="Donald Hoffman’s Conscious Realism proposes consciousness as the foundation of reality, with matter emerging from it. Integrating this with Iamblichean Platonism reveals a co-emergent ontology where matter and psyche arise from an unknowable source. This synthesis bridges modern science, Eastern philosophy, and theurgy, emphasizing harmony between the material and immaterial in humanity’s quest for the divine."
        ></meta>

        <meta property="og:image:width" content="1200"></meta>
        <meta property="og:image:height" content="627"></meta>
        <meta
          property="og:url"
          content="https://www.divineinfinitebeing.com/central-doctrine?chapter=60"
        ></meta>

        <meta name="twitter:card" content="summary_large_image"></meta>
        <meta
          property="twitter:image"
          content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/central_doctrinel_og_img.webp"
        ></meta>
        <meta
          property="twitter:image:alt"
          content="Illustration of a radiant, ethereal figure surrounded by a golden aura, symbolizing the Divine Infinite Being. The figure is positioned centrally, emanating light and energy, with abstract patterns representing spiritual interconnectedness and universal truth."
        ></meta>
        <meta
          name="twitter:url"
          content="https://www.divineinfinitebeing.com/central-doctrine?chapter=60"
        ></meta>
        <meta
          name="twitter:title"
          content="Donald Hoffman’s Conscious Realism and Iamblichean Platonism in Dialogue"
        ></meta>
        <meta
          name="twitter:description"
          content="Blending Donald Hoffman’s Conscious Realism with Iamblichean Platonism yields a vision where consciousness and matter co-emerge from an unknowable ground. This unified reality reflects both modern science and ancient theurgy, honoring the interplay of the material and immaterial. It invites a holistic approach to understanding existence, the cosmos, and humanity’s spiritual ascent toward the divine."
        ></meta>
        <link rel="canonical" href="https://www.divineinfinitebeing.com/central-doctrine?chapter=60" />
      </Head>
      <Common_html BlockData={BlockData} />
    </>
  );
}
